import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pf-website/pf-website/common/Instagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdHandlerService"] */ "/home/runner/work/pf-website/pf-website/components/ads/AdHandlerService.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Outbrain"] */ "/home/runner/work/pf-website/pf-website/components/ads/Outbrain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ParagraphLink"] */ "/home/runner/work/pf-website/pf-website/components/articles/Article/BodyItem/ParagraphLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pf-website/pf-website/components/articles/Article/BodyItem/Poll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EndOfArticle"] */ "/home/runner/work/pf-website/pf-website/components/articles/Article/EndOfArticle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardTracker"] */ "/home/runner/work/pf-website/pf-website/components/articles/CardTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleLink"] */ "/home/runner/work/pf-website/pf-website/components/articles/Link.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pf-website/pf-website/components/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GreenPlayer"] */ "/home/runner/work/pf-website/pf-website/components/media/GreenPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracking"] */ "/home/runner/work/pf-website/pf-website/components/PageTracking.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pf-website/pf-website/components/PFLink.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pf-website/pf-website/components/PFTimeAgo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PubTime"] */ "/home/runner/work/pf-website/pf-website/components/PubTime.tsx");
